<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Import Address</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <a
                    href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/Address_update+-+Sheet1.csv">
                    <v-btn color="white" rounded outlined class="ma-2 downbtn">
                        Download CSV format
                        <v-icon right dark>mdi-cloud-download</v-icon>
                    </v-btn>
                </a>
            </v-toolbar>

            <v-row dense justify="center">
                <v-col sm="4">
                    <v-file-input placeholder="CSV of Address" prepend-icon="mdi-file" label="Import Address" rounded
                        dense flat outlined show-size v-model="file"></v-file-input>
                </v-col>
                <v-col sm="2">
                    <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="load1 == true">

            <span v-if="success_list.length > 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Added Records</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <br />
                <v-data-table :headers="headers" :items="success_list" sort-by class="elevation-1 mytable" dense
                    :search="search" :loading="output_load"></v-data-table>
            </span>
            <span v-if="statuslist.length > 0">
                <v-toolbar dense class="toolbar" flat color="white">
                    <v-toolbar-title>Update Records</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <br />
                <v-data-table :headers="headers" :items="statuslist" sort-by class="elevation-1 mytable" dense
                    :search="search" :loading="output_load"></v-data-table>
            </span>
        </v-card>
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },

    data() {
        return {
            show_scuuess_table: false,
            success_list: [],
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            file: null,
            search: "",
            id: "",
            snackbar: false,
            overlay: false,
            snackbar_msg: "",

            color: "",

            valid: false,
            statuslist: "",

            load1: false,
            load: false,
            dialog: false,
            loading3: false,
            states_list: null,
            city_list: [],





            headers: [
                { text: "Sr.NO", value: "serial_number" },
                { text: "PRN ", value: "prn" },
                { text: "Address", value: "address" },
                { text: "Reason", value: "reason" },
            ],

            output_load: false,
        };
    },

    methods: {

        //     fnExcelReport(id, name) {
        //         let tab_text = `<table border='1px'>
        // <tr>
        //   <th>City Name</th>
        //   <th>State Name</th>


        // </tr>`;

        //         this.city_list.forEach((item, index) => {
        //             tab_text += `
        // <tr>
        //     <td>${item.city || ''}</td> 
        //     <td>${item.state_name || ''}</td> 

        // </tr>`;
        //         });

        //         tab_text += '</table>';

        //         const blob = new Blob([tab_text], {
        //             type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        //         });
        //         const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

        //         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        //             // For IE
        //             window.navigator.msSaveOrOpenBlob(blob, filename);
        //         } else {
        //             // For modern browsers
        //             const url = window.URL.createObjectURL(blob);
        //             const a = document.createElement('a');
        //             a.href = url;
        //             a.download = filename;
        //             a.click();
        //             window.URL.revokeObjectURL(url);
        //         }
        //     },
        submitFile() {
            if (this.file == null) {
                alert("Please select the file!");
            } else {
                this.output_load = true;
                let formData = new FormData();
                formData.append("file", this.file);
                axios
                    .post("admission/importAddress", formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            if (res.data.statuslist[0].failedlist.length > 0) {
                                this.statuslist = res.data.statuslist[0].failedlist;
                                this.load1 = true;

                            }
                            if (res.data.statuslist[0].statuslist.length > 0) {
                                this.success_list = res.data.statuslist[0].statuslist;
                                this.show_scuuess_table = true;
                            }
                        }
                    })
                    .catch(function () {
                        console.log("FAILURE!!");
                    })
                    .finally(() => {
                        this.output_load = false;
                    });
            }


        },


        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

    },
    mounted() {

    }
};
</script>

<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
    font-size: 80%;
}

.downbtn {
    float: right;
}

.even {
    background-color: whitesmoke;
}

.odd {
    background-color: white;
}

.mytable /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.downbtn {
    float: right;
}

.mytable2 /deep/ thead th {
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

/* new css */
table,
th {
    padding: 10px;
    border: 1px solid black;
    border-collapse: collapse;
    background: #0f2027;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right,
            #2c5364,
            #203a43,
            #0f2027);
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.mandatory {
    color: red;
}
</style>
